import { render, staticRenderFns } from "./bf-button.vue?vue&type=template&id=1cd7897c&scoped=true&lang=pug&"
import script from "./bf-button.vue?vue&type=script&lang=js&"
export * from "./bf-button.vue?vue&type=script&lang=js&"
import style0 from "./bf-button.vue?vue&type=style&index=0&id=1cd7897c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd7897c",
  null
  
)

export default component.exports